import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { Loader } from '@tfo/common'
import * as React from 'react'
import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import $http from '../../../../utils/$http'

import { useIntl } from 'react-intl'
import './FinalizeSignature.scss'

interface QueryParams {
    orderId?: string
}

type ValidationError = {
    code: number
    message: string | React.ReactNode
}

const FinalizeSignature: React.FunctionComponent = () => {
    const intl = useIntl()
    const params = useParams<QueryParams>()
    const history = useHistory();
    const orderId = params.orderId
    const [submitError, setSubmitError] = React.useState<ValidationError | null>(null);

    useEffect(() => {
        const finalizeDone = () => {
            history.replace('/candidate')
        }

        if (!orderId) {
            finalizeDone()
        }
        else {
            $http
                .post(`signature/${orderId}/end`, null)
                .then(finalizeDone)
                .catch(e => {
                    const error = e as {
                        response?: {
                            status: number
                            data: {
                                detail: string
                            }
                        }
                    }

                    if (error.response === undefined) {
                        setSubmitError({ code: 998, message: intl.formatMessage({ id: 'startIndividual.signature.998' }) }) // Custom code for offline
                    }
                    else if (error.response.status === 400) {
                        setSubmitError({ code: 400, message: error.response.data.detail})
                    }
                    else if (error.response.status === 409) {
                        setSubmitError({ code: 409, message: error.response.data.detail})
                    }
                    else {
                        setSubmitError({ code: 500, message: intl.formatMessage(
                            { id: 'startIndividual.signature.500' }, 
                            { email: email => <a href={`mailto:${email}`}>{email}</a> }) })
                    }
                });
        }
    }, [orderId, history, intl])
    
    return submitError 
            ? (<div className="FinalizeSignature-Container">
                <div className="FinalizeSignature-ErrorMessage">
                    <ReportProblemOutlinedIcon />
                    <div className="FinalizeSignature-InputErrorMessage">
                        {submitError.message}
                    </div>
                    
                </div>
                <a className='FinalizeSignature-Link' href="/candidate">{intl.formatMessage({ id: 'startIndividual.signature.back' })}</a>
            </div>) 
            : (<Loader />)
}

export default FinalizeSignature